<app-data-table-manager
  [columnConfigs]="columnConfigs"
  [filterConfig]="DEFAULT_FILTER_CONFIG"
  [fieldFilters]="fieldFilters"
  [tableData]="tableData"
  [displayInfo]="displayInfo"
  [domainMarketLang]="domainMarketLang"
  [facetGroups]="facetGroups"
  [tableName]="'variantStep'"
  [defaultSortActive]="defaultSortActive"
  [defaultSortDirection]="defaultSortDirection"
  (loadDataRequested)="loadComments($event)"
></app-data-table-manager>
